export default __webpack_public_path__ + "media/zurb/img/legacy/strike/instructions-5-6f85b91b1b164ebd23b10e9d4d00a39e.jpg";